import SolutionBenefitsI18n from "@/components/landing/shared/SolutionBenefitsI18n";
import { Zap, Target, Users, Award } from "lucide-react";
const KundenserviceBenefitsSection = () => <SolutionBenefitsI18n translationPrefix="kundenserviceSolution" icons={[Zap, Target, Users, Award]} />;
export default KundenserviceBenefitsSection;
